import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

// GoalsPageEmptyState
export const GoalsPageEmptyStateContainer = styled.div`
  align-items: center;
  background-color: ${colors.background.secondaryBackground};
  display: flex;
  flex-direction: column;
  min-height: 570px;
  padding: 80px 0;
  justify-content: center;
  width: 100%;
`

export const HeroText = styled(Typography)`
  ${typography.up3.regularSans}
  padding-top: 24px;
`

export const GoalCreationGuide = styled.div`
  ${typography.baseline.regularSans}
  padding: 24px 0;
`

export const TemplatesCallToActionText = styled(Typography)`
  ${typography.up3.regularSans}
`
export const TemplatesCallToAction = styled.div`
  ${typography.baseline.regularSans}
  padding: 24px 0;
`

export const Anchor = styled.a`
  color: ${colors.interactive.primaryEnabled};
`

// GoalPageEmptyState
export const GoalPageEmptyStateContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 24px;
`

export const Header = styled(Typography)`
  ${typography.up3.regularSans}
  padding-bottom: 20px;
`

export const ContentContainer = styled.div`
  ${typography.baseline.regularSans}
  padding: 40px 0;
`

// GoalSectionEmptyState
export const GoalSectionEmptyStateContainer = styled.div<{ simple?: boolean }>`
  align-items: center;
  background-color: ${({ simple }) =>
    simple ? 'none' : colors.background.secondaryBackground};
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 16px 0;
  width: 100%;
`

export const IconContainer = styled.span`
  align-items: center;
  display: flex;
  color: ${colors.interactive.disabledLight};
`

export const Message = styled(Typography)`
  ${typography.baseline.regularSans}
`
